import React, { MouseEventHandler } from "react";
import { Button, Modal } from "antd";
import "../../css/jobs.css";

interface JobValidateModalTypes {
  onCloseModal: MouseEventHandler<HTMLElement>;
  headerText:string;
  contentText:string
}

function JobValidateModal(props: JobValidateModalTypes) {
  const { headerText,contentText,onCloseModal } = props;

  const renderQuestionsContent = () => {
    return (
      <div className="job_modal_container">
        <text>{headerText}</text>

        <div className="job_question_text_container">
          <text>
          {contentText}
          </text>
        </div>

        <div className="job_question_btn">
          <Button
            type="primary"
            htmlType="submit"
            onClick={(e) => onCloseModal(e)}
          >
            OK
          </Button>
        </div>
      </div>
    );
  };
  return (
    <Modal
      footer={null}
      visible={true}
      className="ant-modal"
      onCancel={(e) => onCloseModal(e)}
    >
      {renderQuestionsContent()}
    </Modal>
  );
}
export default JobValidateModal;
